import { apiCall } from './common';

/* CCI jobs */
export const apiGetCciJobs = async ({ statuses, search, limit, offset }) => await apiCall({
    method: 'GET',
    endpoint: 'cci/jobs',
    params: { status: statuses?.length ? statuses.join(',') : undefined, search: search || undefined, limit, offset },
});
export const apiGetCciJob = async (job_id) => await apiCall({ method: 'GET', endpoint: `cci/jobs/${job_id}` });
export const apiGetCciProfileLog = async (job_id, profile) => await apiCall({
    method: 'GET',
    endpoint: `cci/jobs/${job_id}/profiles/${encodeURIComponent(profile)}/log`,
});
